<div class="wrapping-border">
    <full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>